import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import EventSponsorComponent from '../../../Components/UserComponents/EventSponsor';
import {addSponsorAttendees, getAllChapters} from '../../../Store/Actions';
import {
  getEventOptionsByEventId,
  getEventOptionsById,
} from '../../../Store/Actions/eventOptions';
import {
  createSelectionOptionsUtil,
  createSelectionOptionsUtilForPerks,
} from '../../../Util/commonUtility';
import {
  UpdateAttendee,
  UpdateSponsorById,
  applyCouponCodes,
  deleteAttendee,
  getAttendesByUserAndEventId,
  postAttendee,
  clearAddedRepsParent,
  sponsorRegistrationByUserAndEventId,
} from '../../../Store/Actions/eventRegister';
import {useNavigate, useParams} from 'react-router-dom';
import useLocalization from '../../../Localization';

const EventSponsorContainer = () => {
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const {id, optionId} = useParams();
   const {ApplicationString} = useLocalization();
  const {allAttendees} = useSelector(({eventRegister}) => eventRegister);
  const {getEventOptionByEventId, getEventOptionsData} = useSelector(
    ({eventOptions}) => eventOptions,
  );
  const [eventOptionsFoodData, setEventOptionsFoodData] = useState([]);
  const [listSponsorAttendeesData, setListAttendeesData] = useState();
  const [allEventOptionsFoodData, setAllEventOptionsFoodData] = useState([]);
  const [totalCartPrice, setTotalCartPrice] = useState(0);
  const [eventName, setEventName] = useState('');
  const [eventISOnline, setEventISOnline] = useState(false);
  const [sponsorData, setSponsorData] = useState([]);
  const [eventForDataLength, setEventForDataLength] = useState([]);
  const [attendeesData, setAttendeesData] = useState();
  const [freeLunchLimit, setFreeLunchLimit] = useState();
  const [freeLunchPrice, setFreeLunchPrice] = useState();
  const [eventOptionData, setEventOptionData] = useState([]);
  const [listAttendeesDataWithPerks, setListAttendeesDataWithPerks] =
    useState();
  const [eventType, setEventType] = useState('');
  const [eventLocalChapterData, setEventLocalChapterData] = useState();
  const [appliedCartCoupon, setAppliedCartCoupon] = useState();
  const [isAppliedCoupon, setIsAppliedCoupon] = useState(false);
  const allChapters = useSelector((state) => state.chapters.allChapters);

  useEffect(() => {
    if (!allChapters) {
      dispatch(getAllChapters());
    }
  }, []);

  useEffect(() => {
    if (getEventOptionByEventId) {
      const eventLocalChapterData = allChapters?.data?.chapters?.find(
        (obj) => obj.id === getEventOptionByEventId?.data?.local_chapter_id,
      );
      const foodOptionsWithNoFood = getEventOptionByEventId?.data?.food || [];
      const perksUtilData = createSelectionOptionsUtilForPerks(
        foodOptionsWithNoFood,
        freeLunchLimit,
        freeLunchPrice,
        'id',
        'name',
        eventLocalChapterData,
        'price',
        ApplicationString,
      );
      const regularUtilData = createSelectionOptionsUtil(
        foodOptionsWithNoFood,
        'id',
        'name',
        'price',
        eventLocalChapterData,
      );
      setEventOptionsFoodData([...perksUtilData, ...regularUtilData]);
      setEventLocalChapterData(eventLocalChapterData);
    } else {
      dispatch(getEventOptionsByEventId(id));
    }
  }, [getEventOptionByEventId, freeLunchLimit, freeLunchPrice]);

  useEffect(() => {
    if (eventOptionsFoodData) {
      setAllEventOptionsFoodData([
        ...eventOptionsFoodData,
        {value: 'no-food', label: ApplicationString['addAttendeesComponent.label.noFoodOption']},
      ]);
    }
  }, [eventOptionsFoodData]);

  useEffect(() => {
    if (
      getEventOptionsData
        ? parseInt(optionId) === getEventOptionsData?.data?.id
        : getEventOptionsData
    ) {
      setEventOptionData(getEventOptionsData?.data);
      setFreeLunchLimit(
        getEventOptionsData?.data?.eventSponsorshipPerk?.free_lunch,
      );
      setFreeLunchPrice(
        getEventOptionsData?.data?.eventSponsorshipPerk?.lunch_price,
      );
    } else {
      SponsorAttendeeOptionById(optionId);
    }
  }, [getEventOptionsData]);

  useEffect(() => {
    if (id) {
      fetchSponsorAttendeesList(id);
    }
  }, [id]);
  useEffect(() => {
    if (optionId) {
      SponsorAttendeeOptionById(optionId);
    }
  }, [optionId]);

  useEffect(() => {
    if (allAttendees) {
      const commonDataVar = allAttendees?.data?.event_registrations;
      setEventName(allAttendees?.data?.event_name);
      setEventType(allAttendees?.data?.event_type_name);
      setEventISOnline(allAttendees?.data?.is_online);
      setListAttendeesData(
        commonDataVar?.attendees?.length > 0 ? commonDataVar.attendees : null,
      );
      setListAttendeesDataWithPerks(commonDataVar?.attendeesWithPerks);
      setSponsorData(commonDataVar?.sponsor);
      setTotalCartPrice({
        total_price_per_cart: allAttendees?.data?.total_price,
        discount: allAttendees?.data?.discount,
        discounted_price: allAttendees?.data?.discounted_price,
        refund_credit: allAttendees?.data?.refund_credit,
      });
      setAppliedCartCoupon(allAttendees?.data?.discount_code);
      setEventForDataLength(commonDataVar);
    } else {
      fetchSponsorAttendeesList(id);
    }
  }, [allAttendees, allAttendees?.data?.event_registrations]);

  useEffect(() => {
    if (isAppliedCoupon) {
      fetchSponsorAttendeesList(id);
      setIsAppliedCoupon(false);
    }
  }, [isAppliedCoupon]);

  useEffect(() => {
    if (listSponsorAttendeesData) {
      const Data = Array.isArray(listSponsorAttendeesData)
        ? listSponsorAttendeesData?.map((item) => {
            return {
              ...item,
              food_option: item?.event_registration_options?.food,
              registration_option:
                item?.event_registration_options?.registration,
            };
          })
        : [];
      setAttendeesData(Data);
    }
  }, [listSponsorAttendeesData]);

  const postAttendeesById = async (
    Data,
    setEditingKey,
    form,
    setIsAddAttendee,
    setDisableAttendeeClicks,
    setDisablePaymentClicks,
    setDisableEditClicks,
    setIsSavingAttendee,
  ) => {
    dispatch(
      postAttendee(
        Data,
        setEditingKey,
        form,
        setIsAddAttendee,
        setDisableAttendeeClicks,
        setDisablePaymentClicks,
        setDisableEditClicks,
        setIsSavingAttendee,
      ),
    );
  };

  const postSponsorAttendees = async (Data, setSponsorCreatedSuccessFully) => {
    dispatch(addSponsorAttendees(Data, setSponsorCreatedSuccessFully));
  };

  const updateSponsorAttendee = async (
    Data,
    id,
    setEditingKey,
    form,
    setDisableAttendeeClicks,
    setDisablePaymentClicks,
    setDisableEditClicks,
    setIsSavingAttendee,
  ) => {
    dispatch(
      UpdateAttendee(
        Data,
        id,
        setEditingKey,
        form,
        setDisableAttendeeClicks,
        setDisablePaymentClicks,
        setDisableEditClicks,
        setIsSavingAttendee,
      ),
    );
  };

  const updateSponosor = async (Data, id, setEditDetails) => {
    dispatch(UpdateSponsorById(Data, id, setEditDetails));
  };

  const fetchSponsorAttendeesList = async (id) => {
    const attendeeType = 'sponsor';
    dispatch(getAttendesByUserAndEventId(id, attendeeType));
  };

  const deleteAttendeeById = (id) => {
    dispatch(deleteAttendee(id));
  };
  const SponsorAttendeeOptionById = async (id) => {
    dispatch(getEventOptionsById(id));
  };

  const applyCouponCode = async (Data) => {
    dispatch(applyCouponCodes(Data, setIsAppliedCoupon));
  };

  const paymentByUserRegistration = async (
    eventId,
    optionId,
    attendeeSponsorType,
  ) => {
    localStorage.setItem('attendeeSponsorType', attendeeSponsorType);
    clearAddedRepsParent();
    dispatch(
      sponsorRegistrationByUserAndEventId(
        eventId,
        navigate,
        totalCartPrice?.discounted_price === 0 ||
          totalCartPrice?.total_price_per_cart === 0,
        optionId,
        true,
      ),
    );
  };

  return (
    <div>
      <EventSponsorComponent
        eventName={eventName}
        inPersonRemaining={getEventOptionByEventId?.data?.in_person_remaining}
        eventISOnline={eventISOnline}
        attendeesDataWithPerks={listAttendeesDataWithPerks}
        sponsorPerksData={eventOptionData}
        setListAttendeesData={setListAttendeesData}
        totalCartPrice={totalCartPrice}
        sponsorData={sponsorData}
        allEventOptionsFoodData={allEventOptionsFoodData}
        SponsorAttendeeOptionById={(id) => {
          SponsorAttendeeOptionById(id);
        }}
        fetchSponsorAttendeesList={(id) => {
          fetchSponsorAttendeesList(id);
        }}
        deleteAttendeeById={(id) => {
          deleteAttendeeById(id);
        }}
        allSponsorAttendeesData={attendeesData}
        postSponsorAttendeesById={(Data, setSponsorCreatedSuccessFully) => {
          postSponsorAttendees(Data, setSponsorCreatedSuccessFully);
        }}
        postAttendeesById={(
          Data,
          setEditingKey,
          form,
          setIsAddAttendee,
          setDisableAttendeeClicks,
          setDisablePaymentClicks,
          setDisableEditClicks,
          setIsSavingAttendee,
        ) => {
          postAttendeesById(
            Data,
            setEditingKey,
            form,
            setIsAddAttendee,
            setDisableAttendeeClicks,
            setDisablePaymentClicks,
            setDisableEditClicks,
            setIsSavingAttendee,
          );
        }}
        updateSponosor={(Data, id, setEditDetails) => {
          updateSponosor(Data, id, setEditDetails);
        }}
        updateSponsorAttendee={(
          id,
          Data,
          setEditingKey,
          form,
          setDisableAttendeeClicks,
          setDisablePaymentClicks,
          setDisableEditClicks,
          setIsSavingAttendee,
        ) => {
          updateSponsorAttendee(
            id,
            Data,
            setEditingKey,
            form,
            setDisableAttendeeClicks,
            setDisablePaymentClicks,
            setDisableEditClicks,
            setIsSavingAttendee,
          );
        }}
        eventRegisterData={eventForDataLength}
        eventType={eventType}
        setAttendeesData={setAttendeesData}
        setListAttendeesDataWithPerks={setListAttendeesDataWithPerks}
        eventLocalChapterData={eventLocalChapterData}
        applyCouponCode={applyCouponCode}
        appliedCartCoupon={appliedCartCoupon}
        paymentByUserRegistration={paymentByUserRegistration}
      />
    </div>
  );
};

export default EventSponsorContainer;
